import React, { createContext, useContext, useState } from 'react'

interface SidebarContextData {
  isOpen: boolean
  openSideBar(name: string): void
  closeSideBar(): void
  sideBarName?: string | null
}

const SidebarContext = createContext<SidebarContextData>(
  {} as SidebarContextData
)

function SidebarProvider({ children }: React.PropsWithChildren<{}>) {
  const [isOpen, setIsOpen] = useState(false)
  const [sideBarName, setSideBarName] = useState(null)

  function openSideBar(name) {
    setSideBarName(name)
    setIsOpen(true)
  }

  function closeSideBar() {
    setSideBarName(null)
    setIsOpen(false)
  }

  return (
    <SidebarContext.Provider
      value={{ isOpen, openSideBar, closeSideBar, sideBarName }}
    >
      {children}
    </SidebarContext.Provider>
  )
}

function useSidebar() {
  const context = useContext(SidebarContext)

  return context
}

export { SidebarProvider, useSidebar }
